module.exports = __webpack_public_path__ + "img/huzi.00c0a580.gif";